class BundleSelector extends HTMLElement {
  constructor() {
    super();
    this.addButton = null;
    this.status = null;
    this.atcBtnComparePrice = [];
    this.atcBtnPrice = [];
    this.productRadio = [];
  }

  connectedCallback() {
    this.addButton = this.querySelector(".bundle-add-to-cart");
    this.status = this.querySelector(".bundle-status");

    this.atcBtnComparePrice = this.querySelectorAll(".bundle-atc__compare-price");
    this.atcBtnPrice = this.querySelectorAll(".bundle-atc__price");

    this.productRadio = this.querySelectorAll('input[name="product_option"]');

    this.saveCheckbox = document.querySelector('input[name="save_option"]');

    if (this.saveCheckbox) {
      this.saveCheckbox.addEventListener("change", () => {
        const checkedRadio = this.querySelector('input[name="product_option"]:checked');
        if (checkedRadio) this.syncPrices(checkedRadio);
      });
    }

    const checked = this.querySelector('input[name="product_option"]:checked');
    if (checked) {
      this.syncPrices(checked);
    }

    this.productRadio.forEach((radio) => {
      radio.addEventListener("change", (e) => {
        this.syncPrices(e.target);
      });
    });

    if (this.addButton) {
      this.addButton.addEventListener("click", () => this.addToCart());
    }
  }

  syncPrices(radio) {
    if (!radio) return;

    let priceStr = radio.dataset.price || ""; // "$49.00"
    let numericPrice = Number(priceStr.replace(/[^0-9.-]+/g,"")) || 0;

    if (this.saveCheckbox?.checked) {
      const fixedDiscountCents = Number(this.saveCheckbox.dataset.sellingPlanFixedDiscount || 0);
      const percentDiscount = Number(this.saveCheckbox.dataset.sellingPlanPercentageDiscount || 0);

      if (percentDiscount > 0) {
        numericPrice = numericPrice * (1 - percentDiscount / 100);
      } else if (fixedDiscountCents > 0) {
        numericPrice = numericPrice - (fixedDiscountCents / 100);
      }
    }
    const flooredPrice = Math.floor(numericPrice * 100) / 100;

    const discountedPriceStr = priceStr.replace(
      /[\d.,]+/,
      flooredPrice.toFixed(2)
    );

    const compare = radio.dataset.compare_price || "";
    const available = radio.dataset.available === "true";

    // Price to show: discounted when subscription checked, else regular price
    const displayPriceStr = this.saveCheckbox?.checked ? discountedPriceStr : priceStr;

    // Update main price
    this.atcBtnPrice.forEach(el => {
      el.textContent = displayPriceStr;
    });

    // Update compare price
    this.atcBtnComparePrice.forEach(el => {
      if (compare) {
        el.style.display = "inline";
        el.textContent = compare;
      } else {
        el.style.display = "none";
      }
    });

    // Update ATC label / status
    if (this.status) {
      this.status.textContent = available
        ? this.status.dataset.defaultLabel || "Add to Cart"
        : "Out of Stock";
    }

    // Enable/disable button
    if (this.addButton) {
      this.addButton.disabled = !available;
    }

    // Delivery Notice update
    const notice = document.querySelector('.el-delivery-notice');
    if (notice) {
      const outer = notice.querySelector('.pulse-icon__outer');
      const inner = notice.querySelector('.pulse-icon__inner');
      const stockTextEl = notice.querySelector('.stock-text');

      if (available) {
        stockTextEl.textContent = "In Stock";
        outer.setAttribute('fill', "#5CD33F");
        inner.setAttribute('fill', "#5CD33F");
      } else {
        stockTextEl.textContent = "Out of Stock";
        outer.setAttribute('fill', "red");
        inner.setAttribute('fill', "red");
      }
    }
  }

  async addToCart() {
    const selected = this.querySelector('input[name="product_option"]:checked');
    if (!selected) return;

    const variantId = Number(selected.value);

    const defaultStatus = this.status?.textContent || "";
    if (this.addButton) this.addButton.disabled = true;
    if (this.status) this.status.textContent = "Adding…";

    try {
      const cartDrawer =
        document.querySelector("cart-drawer") ||
        document.querySelector("cart-notification") ||
        document.querySelector("CartDrawer");

      const sections =
        cartDrawer?.getSectionsToRender?.().map((s) => s.id) || [];

      const saveCheckbox = document.querySelector('input[name="save_option"]');

      const sellingPlanId = saveCheckbox?.checked
        ? saveCheckbox.dataset.sellingPlanId
        : null;

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1, // ✅ Always 1 now
              ...(sellingPlanId && { selling_plan: Number(sellingPlanId) }),
            },
          ],
          sections,
          sections_url: window.location.pathname,
        }),
      }); 

      const data = await response.json();
      if (!response.ok) throw new Error(data.description);

      const wasEmpty = cartDrawer?.classList?.contains?.('is-empty');

      if (cartDrawer) {
        if (wasEmpty) {
          // When cart was empty, avoid theme's renderContents (triggers main.js querySelectorAll on null).
          // Refresh drawer by section fetch and replace, then open.
          const sectionHtml = await fetch('/?section_id=cart-drawer').then((r) => r.text());
          const parser = new DOMParser();
          const doc = parser.parseFromString(sectionHtml, 'text/html');
          const newDrawer = doc.querySelector('[id^="CartDrawer"]');
          const currentDrawer = document.querySelector('[id^="CartDrawer"]');
          if (newDrawer && currentDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            cartDrawer.classList.remove('is-empty');
          }
        } else if (typeof cartDrawer.renderContents === "function") {
          cartDrawer.renderContents(data);
        }
      }

      cartDrawer?.open?.();

      if (this.status) {
        this.status.textContent = "Added to cart!";
        this.status.classList.add("bundle-status--success");
      }

      setTimeout(() => {
        if (this.status) {
          this.status.textContent = defaultStatus;
          this.status.classList.remove("bundle-status--success");
        }
        if (this.addButton) this.addButton.disabled = false;
      }, 1500);
    } catch (error) {
      console.error(error);
      if (this.status) this.status.textContent = "Error";
      if (this.addButton) this.addButton.disabled = false;
    }
  }
}

customElements.define("bundle-selector", BundleSelector);